import Image from 'next/image';

interface ComingSoonPageProps {
  title: string;
}

export function ComingSoonPage({ title }: ComingSoonPageProps) {
  return (
    <div className="min-h-screen h-full min-w-screen flex flex-col items-center justify-center bg-linear-to-br from-[#05030E] to-[#0D0B13] px-4 relative">

      <div className="max-w-2xl w-full text-center space-y-8 relative z-10">
        <div className="relative w-80! h-44 mx-auto">
          <Image
            src="/img/v2/icons/soon.webp"
            alt="Próximamente"
            fill
            className="object-contain"
          />
        </div>

        <div className="space-y-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            {title}
          </h1>
        </div>

        <p className="text-white/70 text-lg md:text-xl max-w-md mx-auto">
          Estamos trabajando en esta sección para ofrecerte la mejor experiencia.
        </p>

        <div className="pt-8">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/5 rounded-full border border-white/10">
            <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
            <span className="text-white/80 text-sm">En desarrollo</span>
          </div>
        </div>
      </div>
    </div>
  );
}
